import Backend from 'App/Dataman-Backend';

const {
  apiUrlTrademarks,
  apiUrlTrademarkStatuses,
  apiUrlsTrademarkOffices,
  apiUrlTrademarkHolders,
  apiUrlTrademarkRepresentatives,
  apiUrlTrademarkCorrespondenceAddresses,
  apiNiceClasses,
  apiUrlSuffix,
} = Backend.config;

export const TRADEMARKS_PATHS = {
  trademarks: apiUrlTrademarks,
  statuses: apiUrlTrademarkStatuses,
  offices: apiUrlsTrademarkOffices,
  holders: apiUrlTrademarkHolders,
  representatives: apiUrlTrademarkRepresentatives,
  correspondenceAddresses: apiUrlTrademarkCorrespondenceAddresses,
  niceClasses: apiNiceClasses,
  suffix: apiUrlSuffix,
};
